import convertUnits, { mass, volume } from 'convert-units';
export var convert = convertUnits({
  volume: volume,
  mass: mass
});

var UnitConverter =
/** @class */
function () {
  function UnitConverter(converterInstance) {
    this.convert = converterInstance;
  }

  UnitConverter.prototype.install = function (Vue, options) {
    Vue.prototype.$convert = this.convert;
  };

  return UnitConverter;
}();

export default new UnitConverter(convert);